// const { $ } = require("video.js/dist/types/utils/dom");

var isRTL = $("html").attr("dir") == "rtl" ? true : false,
  winWidth = $(window).width(),
  winHeight = $(window).height();
gsap.registerPlugin(ScrollToPlugin);
$(function () {
  browserDetect();
});

$(window).on("resize orientationchange", function () {
  // Do on resize
  (winWidth = $(window).width()), (winHeight = $(window).height());
});

$(window).on("scroll", function () {
  //Do on Scroll
});

$(window).on("load", function () {
  initTwoByOneSlider();
  initVideoPlayer();
  initVideoModal();
  videoPlayerInit();
  initSliders();
  drivingChangeSlider();
  initAccordion();
  lineRevealAnimation();
  fadeAnimation();
  // initParallaxEffect();
  stickyFaqSect();
});

$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    //Do on ESC press
  }
});

function browserDetect() {
  navigator.sayswho = (function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join("").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  })();
  $("body").addClass(navigator.sayswho);
}

$(document).ready(function () {
  // animateWords();
  dataTrim();
  ChangeToSvg();
  ScrollSmootherInitailize();
  aboutUsAnimation();
});

function dataTrim() {
  var ellipsis = "...";
  $("[data-trim]").each(function () {
    var text = $(this).html();
    var charLimit = parseInt($(this).attr("data-trim"));
    $(this).html(TrimLength(text, charLimit));
    $(this).addClass("is--trimmed");
  });

  function TrimLength(text, maxLength) {
    text = $.trim(text);
    if (text.length > maxLength) {
      text = text.substring(0, maxLength - ellipsis.length);
      return text.substring(0, text.lastIndexOf(" ")) + ellipsis;
    } else return text;
  }
}

function ChangeToSvg() {
  $("img.js-tosvg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        var $svg = $(data).find("svg");
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " insvg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
          );
        }
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}

var smoother;
function ScrollSmootherInitailize() {
  if (window.matchMedia("(min-width: 1200px)").matches) {
    // Destroy existing smoother instance if it exists
    if (smoother) {
      smoother.kill();
    }

    ScrollTrigger.normalizeScroll(true); // Enable for desktop
    smoother = ScrollSmoother.create({
      smooth: 1.3,
      effects: true,
      type: "touch,wheel,pointer",
      wraper: "#smooth-wraper",
      content: "#smooth-content",
    });
  } else {
    // Destroy smoother and revert normalization
    if (smoother) {
      smoother.kill();
      smoother = null;
      ScrollTrigger.normalizeScroll(false); // Disable for mobile
    }
  }
}
window.addEventListener("resize", ScrollSmootherInitailize);

// Function to toggle ScrollSmoother pause state
function toggleSmootherPause() {
  if (window.matchMedia("(min-width: 1200px)").matches) {
    if (!smoother) {
      console.error("ScrollSmoother is not initialized");
      return;
    }
    const isPaused = smoother.paused();
    smoother.paused(!isPaused); // Toggle between true and false
    // console.log(isPaused);
  } else {
    document.body.classList.toggle("no-scroll");
    $("html").toggleClass("no-scroll");
    console.log("no-scroll");
  }
}

// Form Field Validation Start
function formValidation() {
  const submitBtn = document.querySelectorAll(".Formsubmit");
  const validMessage = document.querySelectorAll(".valid-message");

  // Loop through each submit button
  submitBtn.forEach(function (button) {
    button.addEventListener("click", function (event) {
      var form = event.target.closest("form"); // Get the parent form of the clicked button
      var isValid = true;
      // $validMessage.hide();
      $(form)
        .find(".form-row-dropdown, .form-fields-row")
        .each(function () {
          var $select = $(this).find("select");
          var $errorMessage = $(this).find(".error");
          var $select2Container = $(this).find(".select2-container");

          if ($select.val() == null || $select.val() == "1") {
            isValid = false;
            $select2Container.addClass("error-border");
            $errorMessage.show();
          } else {
            $select2Container.removeClass("error-border");
            $errorMessage.hide();
          }
        });

      // Check input fields with the required class within the current form
      $(form)
        .find(".required")
        .each(function () {
          if ($(this).val().trim() === "") {
            isValid = false;
            $(this).addClass("error-border");
            $(this).siblings(".error").show();
          } else {
            $(this).removeClass("error-border");
            $(this).siblings(".error").hide();
          }
        });

      if (!isValid) {
        // event.preventDefault(); // Prevent form submission if validation fails
        validMessage.show();
        // <p class="valid-message body2">Field can't be left empty</p>
      }
    });
  });

  //
  var togglePasswordIcons = document.querySelectorAll(".eye-icon");
  var togglePasswordSlashIcons = document.querySelectorAll(".eye-slash-icon");

  togglePasswordIcons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      togglePasswordVisibility(icon);
    });
  });

  togglePasswordSlashIcons.forEach(function (Slashicon) {
    Slashicon.addEventListener("click", function () {
      togglePasswordVisibility(Slashicon);
    });
  });

  function togglePasswordVisibility(clickedIcon) {
    var passwordField = clickedIcon.parentNode.querySelector(".password-field");
    var relatedIcon = clickedIcon.classList.contains("eye-icon")
      ? clickedIcon.nextElementSibling
      : clickedIcon.previousElementSibling;

    if (passwordField.type === "password") {
      passwordField.type = "text";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    } else {
      passwordField.type = "password";
      clickedIcon.style.display = "none";
      relatedIcon.style.display = "block";
    }
  }
}

// video
function videoPlayerInit() {
  $(".my-video-js").each(function (index) {
    var thisId = $(this).attr("id");
    $(this).addClass("video-js");
    if (!thisId == "") {
      thisId = "video-id-" + index;
      $(this).attr("id", thisId);
    }
    const dataSrc = $(this).data("src");
    if (dataSrc) {
      // Apply data-src to the video src
      $(this).attr("src", dataSrc).removeAttr("data-src");

      // Apply data-src to <source> elements inside the video
      $(this)
        .find("source[data-src]")
        .each(function () {
          $(this).attr("src", $(this).data("src")).removeAttr("data-src");
        });

      // Load the video to apply the sources
      this.load();
    }
    var player = videojs(thisId);
  });
}

function lineRevealAnimation() {
  const elements = document.querySelectorAll(
    '[data-animation-scroll="lineReveal"]'
  );

  if (elements && elements.length > 0) {
    $('[data-animation-scroll="lineReveal"]').each(function () {
      let paragraphElement = $(this);
      let delay = $(this).data("delay") || 0;
      let blur = $(this).data("blur") || 0;
      if (!paragraphElement[0]) {
        return;
      }

      // Split text into lines
      const splitText = new SplitText(paragraphElement[0], { type: "lines" });
      if (!splitText || !splitText.lines) {
        return;
      }

      const lines = splitText.lines;

      // Wrap each line in a div with overflow hidden
      lines.forEach((line) => {
        if (line && line.parentNode) {
          const wrapper = document.createElement("div");
          wrapper.classList.add("line-wrapper");
          wrapper.style.overflow = "hidden";
          line.parentNode.insertBefore(wrapper, line);
          wrapper.appendChild(line);
        }
      });

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: paragraphElement,
          start: "0% 90%",
          end: "100% 0%",
          toggleActions: "play none none none",
        },
      });

      // Animate lines with blur and staggered reveal
      if (lines && lines.length > 0) {
        tl.fromTo(
          lines,
          { opacity: 0, y: 100, filter: `blur(${blur}px)` },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1.2,
            ease: "power2.out",
            stagger: 0.2,
            delay: delay,
          }
        );
      }
    });
  }
}

function lineRevealAnimationAbout(element) {
  if (!element) return;

  const elements = element.querySelectorAll(
    '[data-animation-scroll-about="lineReveal"]'
  );

  if (elements.length > 0) {
    $(elements).each(function () {
      let paragraphElement = $(this);
      let delay = $(this).data("delay") || 0;
      let blur = $(this).data("blur") || 0;
      if (!paragraphElement[0]) return;

      // Split text into lines
      const splitText = new SplitText(paragraphElement[0], { type: "lines" });
      if (!splitText || !splitText.lines) return;

      const lines = splitText.lines;

      // Wrap each line in a div with overflow hidden
      lines.forEach((line) => {
        if (line && line.parentNode) {
          const wrapper = document.createElement("div");
          wrapper.classList.add("line-wrapper");
          wrapper.style.overflow = "hidden";
          line.parentNode.insertBefore(wrapper, line);
          wrapper.appendChild(line);
        }
      });

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: paragraphElement,
          start: "0% 95%",
          end: "100% 0%",
          toggleActions: "play none none none",
        },
        onComplete: () => {
          if (window.innerWidth > 600) {
            element.classList.add("animated"); // Mark animation as completed (only for >600px)
          }
        },
      });

      // Animate lines with blur and staggered reveal
      if (lines.length > 0) {
        tl.fromTo(
          lines,
          { opacity: 0, y: 100, filter: `blur(${blur}px)` },
          {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1,
            ease: "power2.out",
            stagger: 0.1,
            delay: delay,
          }
        );
      }
    });
  }
}

function initializeAnimation() {
  const screenWidth = window.innerWidth;

  if (screenWidth > 600) {
    // Run animation for active `.text-content` (only once)
    document.querySelectorAll(".text-content.active").forEach((element) => {
      if (!element.classList.contains("animated")) {
        lineRevealAnimationAbout(element);
      }
    });

    // Observe for new active elements and animate only once
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.classList.contains("active") &&
          !mutation.target.classList.contains("animated")
        ) {
          lineRevealAnimationAbout(mutation.target);
        }
      });
    });

    // Attach observer to all `.text-content` elements
    document.querySelectorAll(".text-content").forEach((element) => {
      observer.observe(element, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  } else {
    // Below 600px, run animation normally for all elements (no "active" check)
    document
      .querySelectorAll(
        ".text-content [data-animation-scroll-about='lineReveal']"
      )
      .forEach((element) =>
        lineRevealAnimationAbout(element.closest(".text-content"))
      );
  }
}

// Initialize animation on load and window resize
initializeAnimation();
window.addEventListener("resize", initializeAnimation);

// fadeUp Animtaion
function fadeAnimation() {
  $("[data-animation-type]").each(function () {
    let element = $(this);
    let delay = element.data("delay") || 0;
    let blur = element.data("blur") || 0;
    let animationType = element.data("animation-type") || "fade-down"; // Default: fade-down

    let animationProps = {};

    // Define animation properties based on the data attribute
    if (animationType === "fade-right") {
      animationProps = {
        opacity: 0,
        x: isRTL ? -200 : 200,
        filter: `blur(${blur}px)`,
      }; // Move from right
    } else if (animationType === "fade-down") {
      animationProps = { opacity: 0, y: -10, filter: `blur(${blur}px)` }; // Move from top to bottom
    } else if (animationType === "fade-up") {
      animationProps = { opacity: 0, y: 50, filter: `blur(${blur}px)` }; // Move from bottom to top
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "0% 95%",
        end: "100% 0%",
        toggleActions: "play none none none",
      },
    });

    // Animate the whole element
    tl.fromTo(element, animationProps, {
      opacity: 1,
      x: 0,
      y: 0,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power2.out",
      delay: delay,
    });
  });
}

//about us section
function aboutUsAnimation() {
  const textContents = document.querySelectorAll(".text-content");
  const images = document.querySelectorAll(".content-image");
  const aboutUsSection = document.querySelector(".about-us");

  let sections = images.length;

  // Create responsive animation
  let mm = gsap.matchMedia();

  mm.add("(min-width: 661px)", () => {
    // Destroy existing ScrollTriggers for this section
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.trigger === aboutUsSection) {
        trigger.kill();
      }
    });

    // Create a timeline synced with scroll smoother
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: aboutUsSection,
        start: "top top",
        end: `+=${sections * 60}%`,
        pin: true,
        pinSpacing: true,
        scrub: 1,
        onUpdate: function (self) {
          let progress = self.progress;
          let sectionProgress = progress * sections; // Convert progress into sections

          // Ensure a section changes when it's at least 50% visible
          let sectionIndex = Math.min(
            Math.max(Math.round(sectionProgress - 1), 0),
            sections - 1
          );

          textContents.forEach((content, index) => {
            content.classList.toggle("active", index === sectionIndex);
          });
        },
      },
    });

    // Animate images
    images.forEach((img, index) => {
      tl.to(images, {
        yPercent: -100 * index,
        duration: 1,
        ease: "power1.inOut",
      });
    });

    // Initial state setup
    textContents.forEach((content, index) => {
      content.classList.toggle("active", index === 0);
    });

    // Refresh ScrollTrigger only for this animation
    ScrollTrigger.refresh();

    // Cleanup function when media query does not match
    return () => {
      tl.kill();
    };
  });
}

// how we work slider
function initSliders() {
  $(".image-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    centerMode: true,
    centerPadding: "8.75rem",
    verticalSwiping: true,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1800,
    cssEase: "ease-in-out",
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: true,

    responsive: [
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          centerMode: true,
          centerPadding: "10%",
          verticalSwiping: false,
          adaptiveHeight: false,
          speed: 1000,
          infinite: true,
          initialSlide: 1,
          fade: false,
          arrows: true,
          rtl: isRTL,
        },
      },
    ],
  });

  $(".image-slider").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(".accordion-item").removeClass("active");
      $(".accordion-item").eq(nextSlide).addClass("active");
    }
  );
}

$(".accordion-item").on("click", function () {
  let slideIndex = $(this).index();
  $(".accordion-item").removeClass("active");
  $(this).addClass("active");
  $(".image-slider").slick("slickGoTo", slideIndex, false);
});

// header
let lastScrollTop = 0;

window.addEventListener("scroll", function () {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // Scrolling Down
    document.body.classList.add("scrollDown");
    document.body.classList.remove("scrollUp");
  } else {
    // Scrolling Up
    document.body.classList.add("scrollUp");
    document.body.classList.remove("scrollDown");
  }

  // Agar page bilkul top per hai toh scrollUp remove kar do
  if (scrollTop === 0) {
    document.body.classList.remove("scrollUp");
    document.body.classList.remove("scrollDown");
  }

  lastScrollTop = scrollTop;
});

// input field validate
// function validateEmailInput(input, errorElement, errorContainer) {
//   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   const emailValue = input.value.trim();
//   const icon = document.querySelector(".check-icon");
//   const icon1 = document.querySelector(".icon-1");

//   if (emailValue === "") {
//     // errorElement.textContent = "Field can't be left empty";
//     errorContainer.style.display = "flex";
//     // errorContainer.style.backgroundColor = "#C64837"; // Error background
//     icon1.style.display = "block";
//     icon.style.display = "none";
//     return false;
//   } else if (!emailPattern.test(emailValue)) {
//     // errorElement.textContent = "Invalid email address";
//     errorContainer.style.display = "flex";
//     // errorContainer.style.backgroundColor = "#C64837"; // Error background
//     icon1.style.display = "block";
//     icon.style.display = "none";
//     return false;
//   } else {
//     // errorContainer.style.display = "none"; // Success background
//     icon1.style.display = "none";
//     icon.style.display = "block";

//     return true;
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const responses = document.querySelector(".mce-responses");

//   console.log(responses, "responseeeeeeeeeee");
//   // const errorMessage = document.querySelector(".error-message");
//   // const errorContainer = document.querySelector(".message-show");
//   // const form = document.querySelector(".subscribe-form");
//   // const icon1 = document.querySelector(".icon-1");
//   // const icon = document.querySelector(".check-icon");

//   // if (form) {
//   //   // Live validation
//   //   emailInput.addEventListener("input", function () {
//   //     validateEmailInput(emailInput, errorMessage, errorContainer);
//   //   });

//   //   // Hide error message on blur if the field is empty
//   //   emailInput.addEventListener("blur", function () {
//   //     if (emailInput.value.trim() === "") {
//   //       errorContainer.style.display = "none";
//   //     }
//   //   });

//   // Form submission validation
//   form.addEventListener("submit", function (event) {
//     event.preventDefault();
//     // if (validateEmailInput(emailInput, errorMessage, errorContainer)) {
//     //   addAnalytics();
//     //   emailInput.value = "";

//     //   // Show success message
//     //   errorContainer.style.display = "flex";
//     //   errorContainer.style.backgroundColor = "#B3C5B3"; // Success background
//     //   errorMessage.textContent = "Thank you! Subscription successful!";
//     //   errorMessage.style.color = "#1C211E"; // Dark green text
//     //   icon.style.display = "block";
//     // }
//   });
//   // }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const successResponse = document.getElementById("mce-success-response");
//   const errorMessages = document.querySelectorAll(".mce_inline_error");

//   // console.log(successResponse, errorMessages, "esgaeeeeeeeeeeeeeeeee");

//   // if (errorMessages) {
//   //   successResponse.style.display = "none !important";
//   // }
//   // if (successResponse) {
//   //   addAnalytics();
//   //   setTimeout(() => {
//   //     successResponse.style.display = "none !important";
//   //   }, 3000);
//   // }s
// });

function checkAndHide() {
  setTimeout(() => {
    const errorResponse = document.getElementById("mce-error-response");
    const successResponse = document.getElementById("mce-success-response");
    const inlineErrors = document.querySelectorAll(".mce_inline_error");

    const isErrorVisible =
      errorResponse &&
      window.getComputedStyle(errorResponse).display === "block";
    const isSuccessVisible =
      successResponse &&
      window.getComputedStyle(successResponse).display === "block";
    const isInlineErrorVisible = Array.from(inlineErrors).some(
      (error) => window.getComputedStyle(error).display === "block"
    );

    if (isInlineErrorVisible) {
      if (isErrorVisible) {
        errorResponse.style.display = "none";
      }
      if (isSuccessVisible) {
        successResponse.style.display = "none";
      }
    }
  }, 100);
}

// Attach event listener to the form
document.addEventListener("DOMContentLoaded", function () {
  const subscribeForm = document.getElementById("mc-embedded-subscribe-form");

  if (subscribeForm) {
    subscribeForm.addEventListener("submit", function () {
      checkAndHide(); // Delay checking to allow Mailchimp messages to update
      addAnalytics();
    });
  }
});

function addAnalytics() {
  // Initialize the dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "form_submit",
    category: "form_submit",
    action: "submit",
    label: "newsletter form",
    page: window.location.href,
  });
}

// scroll to the next section
function scrollToNextSection() {
  let nextSection = document.querySelector(".new-footer-section");
  if (nextSection) {
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: nextSection, offsetY: 0 },
      ease: "power2.inOut",
    });
  }
}

let btns = document.querySelectorAll(".btn_go_to_next");

if (btns.length > 0) {
  btns.forEach((btn) => {
    btn.addEventListener("click", scrollToNextSection);
  });
} else {
}

// driving Change Slider
function drivingChangeSlider() {
  // Initialize Slick Slider for images
  $(".imageContainer").slick({
    vertical: true,
    verticalSwiping: true, // Enable vertical swiping
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false, // Hide navigation arrows
    dots: false,
  });

  // Update slide when clicking on menu items
  $(".subtitle").click(function () {
    let index = $(this).index(); // Get index of clicked item

    // Change slide in Slick
    $(".imageContainer").slick("slickGoTo", index);

    // Update active state in menu
    $(".subtitle").removeClass("active");
    $(this).addClass("active");

    // Update active state in text content
    $(".keyProgramContent").removeClass("active");
    $(".keyProgramContent").eq(index).addClass("active");
  });

  // Update active classes on vertical swipe
  $(".imageContainer").on("afterChange", function (event, slick, currentSlide) {
    // Update the active state in the menu
    $(".subtitle").removeClass("active");
    $(".subtitle").eq(currentSlide).addClass("active");

    // Update the active state in the text content
    $(".keyProgramContent").removeClass("active");
    $(".keyProgramContent").eq(currentSlide).addClass("active");
  });
}

//accordian
function initAccordion(selector = ".keyProgramContainerSm .main-accordion") {
  const accordions = document.querySelectorAll(selector);

  // console.log(accordions, "initAccordion");
  if (!accordions.length) {
    return;
  }

  const allAccordionHeaders = document.querySelectorAll(
    `${selector} .accordion-header`
  );

  allAccordionHeaders.forEach(function (item) {
    item.addEventListener("click", function () {
      const isActive = item.classList.contains("active");

      allAccordionHeaders.forEach(function (i) {
        i.classList.remove("active");
        i.nextElementSibling.style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add("active");
        item.nextElementSibling.style.maxHeight =
          item.nextElementSibling.scrollHeight + "px";
      }
    });
  });
}

// driving changes tabs
function activeTap(index) {
  const menuItems = document.querySelectorAll(".keyProgramLeft .subtitle");
  const images = document.querySelectorAll(".programImage");
  const contents = document.querySelectorAll(".keyProgramContent");

  // Remove active class from all menu items and text contents
  menuItems.forEach((item) => item.classList.remove("active"));
  contents.forEach((content) => content.classList.remove("active"));

  // Add active class to the clicked item and corresponding content
  menuItems[index].classList.add("active");
  contents[index].classList.add("active");

  // Find the currently active image
  let currentIndex = Array.from(images).findIndex((img) =>
    img.classList.contains("active")
  );

  if (currentIndex !== -1 && currentIndex !== index) {
    // Reset any existing movement classes
    images[currentIndex].classList.remove("moveUp", "moveDown");

    if (index > currentIndex) {
      // Moving forward → slide old one up
      images[currentIndex].classList.add("moveUp");
    } else {
      // Moving backward → slide old one down
      images[currentIndex].classList.add("moveDown");
    }

    setTimeout(() => {
      images[currentIndex].classList.remove("active", "moveUp", "moveDown");
    }, 500); // Wait for transition to complete
  }

  // Add active class to the new image
  images[index].classList.add("active");
}

function initVideoPlayer() {
  let playButton = document.querySelector(".icon-box");
  let innerContent = document.querySelector(".inner--content");
  let video = document.getElementById("videoBannerPoster");

  if (!playButton || !innerContent || !video) return;

  playButton.addEventListener("click", function () {
    // Hide inner content smoothly
    gsap.to(innerContent, {
      opacity: 0,
      duration: 0.2,
      onComplete: function () {
        innerContent.style.display = "none";
      },
    });

    // Remove poster and play the video
    video.removeAttribute("poster"); // Remove poster before playing
    video.style.display = "block";
    gsap.fromTo(video, { opacity: 0 }, { opacity: 1, duration: 0.5 });
    video.play();
  });
}

// video modal

function initVideoModal() {
  const openModalBtns = document.querySelectorAll("#openVideoModal");
  const videoModal = document.getElementById("videoModal");
  const closeModalBtn = document.querySelector(".close-modal");
  const modalVideo = document.getElementById("videoBannerPoster");

  if (!openModalBtns.length || !videoModal || !closeModalBtn) {
    return;
  }

  if (!modalVideo) {
    console.error("Video element not found. Check the ID in your HTML.");
    return;
  }

  function openModal() {
    gsap.set(videoModal, { zIndex: 999 });
    gsap.to(videoModal, {
      opacity: 1,
      visibility: "visible",
      duration: 0.5,
      ease: "power2.out",
    });
    modalVideo.play();
    toggleSmootherPause();
  }

  function closeModal() {
    gsap.to(videoModal, {
      opacity: 0,
      visibility: "hidden",
      duration: 0.5,
      ease: "power2.in",
      onComplete: () => {
        if (modalVideo) {
          // Check before calling pause
          modalVideo.pause();
          modalVideo.currentTime = 0;
          toggleSmootherPause();
        }
      },
    });
  }

  openModalBtns.forEach((btn) => {
    btn.addEventListener("click", openModal);
  });
  closeModalBtn.addEventListener("click", closeModal);

  videoModal.addEventListener("click", function (event) {
    if (event.target === videoModal) {
      closeModal();
    }
  });
}

function initParallaxEffect() {
  const imgBoxes = document.querySelectorAll(".img_box img");

  imgBoxes.forEach((img) => {
    gsap.to(img, {
      yPercent: -15,
      ease: "none",
      scrollTrigger: {
        trigger: img.parentElement,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    });
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       mutation.addedNodes.forEach((node) => {
//         if (
//           node.nodeType === 1 &&
//           node.classList.contains("mce_inline_error")
//         ) {
//           // Check if icon is already added to prevent duplication
//           if (!node.querySelector(".error-icon")) {
//             const img = document.createElement("img");
//             img.src = "/assets/img/icon/close-icon.svg";
//             img.alt = "Error";
//             img.classList.add("error-icon");

//             // Insert the icon before the text
//             node.prepend(img);
//           }
//         }
//       });
//     });
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });
function stickyFaqSect() {
  if (window.innerWidth > 600) {
    const leftContainer = document.querySelector(".faqLeftContainer");
    const rightContainer = document.querySelector(".faqRightContainer");
    const remToPx = (rem) =>
      rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const startOffset = remToPx(7.5);
    if (leftContainer && rightContainer) {
      gsap.to(leftContainer, {
        y: () => rightContainer.scrollHeight - leftContainer.scrollHeight,
        ease: "none",
        scrollTrigger: {
          trigger: rightContainer,
          start: `top-=${startOffset} top`,
          end: () =>
            `+=${rightContainer.scrollHeight - leftContainer.scrollHeight}`,
          scrub: true,
        },
      });
    }
  }
}


function initTwoByOneSlider() {
  const $slider = $('.two-by-one-slider');
  const $dotsWrapper = $('.dots-wrapper');
  const $prevBtn = $('.custom-prev');
  const $nextBtn = $('.custom-next');

  // Store original HTML of each .post-content with animations intact
  const originalPostContents = [];

  function saveOriginals() {
    originalPostContents.length = 0; // reset
    $slider.find('.post-content').each(function () {
      originalPostContents.push($(this).prop('outerHTML'));
    });
  }

  // Remove all data-animation-* attributes from html string
  function stripAnimations(html) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.name.startsWith('data-animation-')) {
          el.removeAttribute(attr.name);
        }
      });
    });
    return tempDiv.innerHTML;
  }

  // Update animation attributes on post-content elements
  // function updateAnimationAttributes() {
  //   const windowWidth = $(window).width();
  //   const keepCount = windowWidth >= 600 ? 2 : 1;

  //   $slider.find('.post-content').each(function (index) {
  //     if (index < keepCount) {
  //       $(this).replaceWith(originalPostContents[index]);

  //     } else {
  //       const cleanHtml = stripAnimations(originalPostContents[index]);
  //       $(this).replaceWith(cleanHtml);
  //     }
  //   });
  // }

  function updateAnimationAttributes() {
    const windowWidth = $(window).width();
  
    $slider.find('.post-content').each(function (index) {
      if (windowWidth >= 600 && index < 2) {
        // Large: keep first 2
        $(this).replaceWith(originalPostContents[index]);
      } else {
        // Small: remove all
        const cleanHtml = stripAnimations(originalPostContents[index]);
        $(this).replaceWith(cleanHtml);
      }
    });
  }

  // Group slides function: groups every 2 <a> into a div.slide-group on desktop, unwrap on mobile
  function groupSlides() {
    const windowWidth = $(window).width();

    if (windowWidth >= 600) {
      if (!$slider.children('div.slide-group').length) {
        const $links = $slider.children('a.sec-content').detach();

        for (let i = 0; i < $links.length; i += 2) {
          const $slideGroup = $('<div class="slide-group"></div>');
          $slideGroup.append($links.slice(i, i + 2));
          $slider.append($slideGroup);
        }
      }
    } else {
      if ($slider.children('div.slide-group').length) {
        const $groups = $slider.children('div.slide-group');
        $groups.children('a.sec-content').appendTo($slider);
        $groups.remove();
      }
    }
  }

  // Initialize slick with custom nav setup
  function initSlick() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      $slider.append($dotsWrapper.children());
    }

    groupSlides();

    // Save originals after grouping
    saveOriginals();

    // Update animations attributes based on viewport & slide index
    updateAnimationAttributes();

    $slider.slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      // fade: true,
        rtl: isRTL,
    });

    $dotsWrapper.append($slider.find('.slick-dots'));
    $slider.find('.slick-arrow').hide();

    $prevBtn.off('click').on('click', () => {
      $slider.slick('slickPrev');
    });

    $nextBtn.off('click').on('click', () => {
      $slider.slick('slickNext');
    });

    $slider.off('afterChange').on('afterChange', (event, slick, currentSlide) => {
      $prevBtn.prop('disabled', currentSlide === 0);
      $nextBtn.prop('disabled', currentSlide === slick.slideCount - 1);
    });

    $prevBtn.prop('disabled', true);
  }

  initSlick();

  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initSlick();
    }, 200);
  });
}